<template>
  <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :title="title" :size="'lg'" :centered="true" :btn_cancel="true"
    :btn_ok="true" :booTitile="true">
    <div class="container">
      <div v-for="(barberDetail) in dataPersonal" :key="barberDetail.id">
        <div class="">
          <div class="mb-2">
            <label><strong>{{ barberDetail.barber.name }} {{ barberDetail.barber.last_name }}</strong></label>
            <div class="form-group form-check">
              <input type="checkbox" class="form-check-input" v-model="barberDetail.state" :true-value="1"
                :false-value="0" :disabled="terminado == 3 && barberDetail.state == 1" />
              <label class="form-check-label" for="defaultCheck1">
                Completado
              </label>
            </div>
          </div>
          <label>Servicios</label>
          <div xl="12" md="12" sm="12" xs="12">
            <v-select v-model="barberDetail.services_ids" :reduce="(service) => service.id" :options="dataServices"
              placeholder="Seleccione varias opciones..." label="label" :close-on-select="false" multiple
              @input="updateServiceTable(barberDetail)" />
          </div>

          <!-- Tabla de Servicios -->
          <div class="table-responsive">
            <table class="table mt-3 table-sm table-hover table-bordered dt-responsive nowrap">
              <thead>
                <tr>
                  <th>Servicio</th>
                  <th>Cantidad</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(service, index) in barberDetail.selectedServices" :key="service.id">
                  <td>{{ service.label }}</td>
                  <td>
                    <input type="number" v-model.number="service.quantity" min="1" :max="getMaxQuantity(service.id)"
                      class="form-control" @input="validateQuantity(service)" />
                  </td>
                  <td>
                    <button class="btn btn-danger" @click="removeService(barberDetail, index)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="form-group">
            <textarea class="form-control" v-model="barberDetail.detail_service"
              placeholder="Escribe la descripción aquí..."></textarea>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <CButton class="btn-secondary" @click="mtdClose" :style="{ color: 'black' }">
        <i class="fa fa-times"></i>&nbsp;Cerrar
      </CButton>
      <CButton @click="saveDescription" class="btn-info">
        <i class="fa fa-save"></i>&nbsp;Guardar
      </CButton>
    </template>
  </CModal>
</template>

<script>
import CModal from "../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";

export default {
  name: "c-addDescription-modal",
  components: {
    CModal,
  },
  data() {
    return {
      swal: null,
      data: [],
      terminado: 0,
      dataPersonal: [],
      dataServices: [],
    };
  },
  props: {
    title: String,
    boo_modal: Boolean,
    id_reserva: Number,
    item: Object,
  },
  watch: {
    boo_modal(newVal) {
      if (newVal) {
        
        this.dataServices = this.item.detail.map((element) => ({
          id: element.service.id,
          label: element.service.name,
          price: parseFloat(element.service.price),
        }));

        this.dataPersonal = this.item.barber_detail.map((barberDetail) => {
          const parsedServices = JSON.parse(barberDetail.services_ids || "[]"); // Convertir string a array

          return {
            ...barberDetail,
            state: barberDetail.state ? 1 : 0,
            services_ids: parsedServices.map(service => service.id), // Solo IDs
            selectedServices: parsedServices, // Objetos completos
          };
        });
        this.terminado = this.item.state;
      }
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose(refresh = false) {
      this.$emit("closeModalDescription", refresh);
    },

    updateServiceTable(barberDetail) {
      // Obtener el último servicio seleccionado
      const lastSelectedId = barberDetail.services_ids[barberDetail.services_ids.length - 1];

      // Si no hay servicio seleccionado, salir
      if (!lastSelectedId) return;

      let existingService = barberDetail.selectedServices.find(s => s.id === lastSelectedId);

      const maxQuantity = this.getMaxQuantity(lastSelectedId);
      const totalAssigned = this.getTotalAssignedQuantity(lastSelectedId);

      // Si ya se alcanzó el máximo para este servicio, impedir agregarlo
      if (totalAssigned >= maxQuantity) {
        Swal.fire({
          title: "Cantidad máxima alcanzada",
          text: `No puedes agregar más de ${maxQuantity} de este servicio entre todo el personal.`,
          icon: "warning",
        });

        // Remover solo el servicio recién agregado
        barberDetail.services_ids = barberDetail.services_ids.filter(id => id !== lastSelectedId);
        return;
      }

      if (!existingService) {
        const newService = this.dataServices.find(s => s.id === lastSelectedId);
        if (newService) {
          existingService = { ...newService, quantity: 1 }; // Agregar con quantity: 1
          barberDetail.selectedServices.push(existingService);
        }
      }
    },
    removeService(barberDetail, index) {
      barberDetail.selectedServices.splice(index, 1);
      barberDetail.services_ids = barberDetail.selectedServices.map(s => s.id);
    },
    getMaxQuantity(serviceId) {
      if (!this.item || !this.item.detail) return 1; // Evitar error si item no está cargado
      const foundService = this.item.detail.find(detail => detail.service_id === serviceId);
      return foundService ? parseInt(foundService.quantity) : 1;
    },
    saveDescription: function () {
      this.post({
        url: `${this.$store.getters.get__url}/barber/addDescription/${this.$store.getters.get_company.id}/${this.$store.getters.get_campu.id}`,
        token: this.$store.getters.get__token,
        params: {
          id: this.id_reserva,
          dataDetail: this.dataPersonal,
        }
      }).then((response) => {
        if (response.statusCode == 200) {
          Swal.fire({
            title: "Se guardo correctamente",
            icon: "success"
          });
          this.mtdClose(true);
        }
      });
    },
    validateQuantity(service) {
      const maxQuantity = this.getMaxQuantity(service.id);
      const totalAssigned = this.getTotalAssignedQuantity(service.id);

      if (totalAssigned > maxQuantity) {
        const availableQuantity = maxQuantity - (totalAssigned - service.quantity);
        service.quantity = Math.max(availableQuantity, 0);

        Swal.fire({
          title: "Cantidad excedida",
          text: `El máximo permitido para este servicio es ${maxQuantity} entre todo el personal.`,
          icon: "warning",
        });
      }
    },
    getTotalAssignedQuantity(serviceId) {
      return this.dataPersonal.reduce((sum, bd) => {
        return sum + (bd.selectedServices.find(s => s.id === serviceId)?.quantity || 0);
      }, 0);
    }
  },
};
</script>
